module.exports = __webpack_public_path__ + "static/media/Folxtale.f89f7f2d.PNG";